function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  background-color: bg;\n  padding: 7 20 5;\n  border: none;\n\n  font-size: 12px;\n\n  box-shadow: inset 1px 1px 0px 1px ", ",\n    inset 0 0 0 1px ", ", 1px 1px 0 0px ", ";\n\n  &:disabled {\n    color: grays.3;\n  }\n\n  &:focus {\n    outline: ", "px dotted ", ";\n    outline-offset: -", "px;\n\n    box-shadow: inset 1px 1px 0px 1px ", ",\n      inset -0.5px -0.5px 0px 1px ", ",\n      1px 1px 0 1px ", ";\n  }\n\n  &:active {\n    padding: 8 20 4;\n\n    outline: ", "px dotted ", ";\n    outline-offset: -", "px;\n\n    box-shadow: inset 0 0 0 1px ", ",\n      0 0 0 1px ", ";\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}

import styled from '@xstyled/styled-components';
import { th } from '@xstyled/system';
var Button = styled.button(_templateObject(), th('colors.white'), th('colors.grays.3'), th('colors.black'), th('space.1'), th('colors.black'), th('space.5'), th('colors.white'), th('colors.grays.3'), th('colors.black'), th('space.1'), th('colors.black'), th('space.5'), th('colors.grays.3'), th('colors.black'));
Button.defaultProps = {
  children: 'Ok'
};
export default Button;